module.exports = __webpack_public_path__ + "arrow_back-44430f0176649a84410c01c26d70e774.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/DocumentsTable/Images/arrow_back.png
// module id = ZOQn
// module chunks = client